

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { BCard, BTable, BBadge } from 'bootstrap-vue'
import EtpGauge from '@/components/staffing/EtpGauge.vue'
import { StaffingEntrepriseDetail, StaffingStatut } from '@/api/models/staffing/staffing'

@Component({
  components: { BCard, BTable, BBadge, EtpGauge },
  name: 'staffing-entreprise-card'
})
export default class StaffingEntrepriseCard extends Vue {
  @Prop({ required: true, type: String }) entrepriseId!: string

  staffing: StaffingEntrepriseDetail | null = null

  siteFields = [
    { key: 'siteLibelle', label: 'Site' },
    { key: 'etpAttendu', label: 'ETP attendu' },
    { key: 'etpStaffe', label: 'ETP staffé' },
    { key: 'ecart', label: 'Écart' },
    { key: 'statut', label: 'Statut' }
  ]

  intervenantFields = [
    { key: 'nomComplet', label: 'Intervenant' },
    { key: 'etpAlloue', label: 'ETP alloué' }
  ]

  ecartClass(value: number | undefined | null): string {
    if (value == null) return ''
    if (value > 0.05) return 'text-warning font-weight-bold'
    if (value < -0.05) return 'text-danger font-weight-bold'
    return 'text-success'
  }

  statutLabel(s: StaffingStatut): string {
    if (s === 'sur') return 'Sur-staffé'
    if (s === 'sous') return 'Sous-staffé'
    return 'OK'
  }

  badgeVariant(s: StaffingStatut): string {
    if (s === 'sur') return 'light-warning'
    if (s === 'sous') return 'light-danger'
    return 'light-success'
  }

  async mounted() {
    await this.load()
  }

  @Watch('entrepriseId')
  async onEntrepriseIdChange() {
    await this.load()
  }

  async load() {
    try {
      this.staffing = await this.$http.myressif.entreprises.getStaffing(this.entrepriseId)
    } catch {
      this.staffing = null
    }
  }

  formatEtp(value: number | undefined | null): string {
    if (value == null || isNaN(value)) return '—'
    return Number(value).toFixed(2)
  }
}
